import { Component } from "react";

import { StatusDisplay } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

import {
    LienWaiverStatusImages,
    LienWaiverStatusTypes,
} from "entity/lienWaiver/LienWaiver/LienWaiver.api.types";

interface ILienWaiverStatusProps {
    status: LienWaiverStatusTypes;
    text: string;
}

const getLienWaiverStatusColor = (status: LienWaiverStatusTypes) => {
    switch (status) {
        case LienWaiverStatusTypes.Approved:
        case LienWaiverStatusTypes.BuilderApproved:
            return "success";
        case LienWaiverStatusTypes.BuilderDeclined:
        case LienWaiverStatusTypes.Declined:
        case LienWaiverStatusTypes.Void:
            return "danger";
        case LienWaiverStatusTypes.Released:
            return "pending";
        default:
            return "";
    }
};

export class LienWaiverStatus extends Component<ILienWaiverStatusProps> {
    render() {
        return (
            <StatusDisplay statusType={getLienWaiverStatusColor(this.props.status)}>
                {this.props.text}
            </StatusDisplay>
        );
    }
}

export const LienWaiverStatusDescriptions = new Map<LienWaiverStatusTypes, string>([
    [LienWaiverStatusTypes.Unreleased, "Unreleased"],
    [LienWaiverStatusTypes.Released, "Pending"],
    [LienWaiverStatusTypes.Approved, "Approved"],
    [LienWaiverStatusTypes.BuilderApproved, "Approved"],
    [LienWaiverStatusTypes.Declined, "Declined"],
    [LienWaiverStatusTypes.BuilderDeclined, "Declined"],
    [LienWaiverStatusTypes.Void, "Void"],
]);

interface ILienWaiverStatusTagProps {
    status: LienWaiverStatusTypes;
}

export class LienWaiverStatusTag extends Component<ILienWaiverStatusTagProps> {
    render() {
        return (
            <StatusTagDisplay
                statusType={getLienWaiverStatusColor(this.props.status)}
                statusText={LienWaiverStatusDescriptions.get(this.props.status)}
            />
        );
    }
}

interface ILienWaiverStatusIconProps {
    status: LienWaiverStatusTypes;
}

export class LienWaiverStatusIcon extends Component<ILienWaiverStatusIconProps> {
    private getStatusIcon = () => {
        switch (this.props.status) {
            case LienWaiverStatusTypes.Released:
                return LienWaiverStatusImages.Pending;
            case LienWaiverStatusTypes.Approved:
                return LienWaiverStatusImages.SubApproved;
            case LienWaiverStatusTypes.BuilderApproved:
                return LienWaiverStatusImages.BuilderApproved;
            case LienWaiverStatusTypes.Declined:
            case LienWaiverStatusTypes.BuilderDeclined:
                return LienWaiverStatusImages.Declined;
            case LienWaiverStatusTypes.Void:
                return LienWaiverStatusImages.Void;
            default:
                return LienWaiverStatusImages.Unreleased;
        }
    };
    render() {
        return (
            <img
                src={this.getStatusIcon().toString()}
                alt={LienWaiverStatusDescriptions.get(this.props.status)}
            />
        );
    }
}
